export default {"src":"/_next/static/media/coming_soon_outfit.d4cf9776.svg","height":30,"width":194,"blurWidth":0,"blurHeight":0};